import React, { useEffect, useState } from "react";
import Button from "../../../form/Button";
import Radio from "../../../form/Radio";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";
import Image from "../../../elements/Image";
import VenmoScanImage from "../../../../assets/image/venmo-scan.webp";
import CashAppScanImage from "../../../../assets/image/cashapp-scan.webp";
import { classNames } from "../../../../helpers/classNames";
import {
  addMonthlyPayment,
  addOneTimePayment,
  paymentMethodList,
} from "../../../../services/PaymentService";
import { toast } from "react-toastify";
import useFetch from "../../../../hooks/useFetch";
import Checkbox from "../../../form/Checkbox";
import PopUpModal from "../../../common/PopUpModal";
import SelectDropdownImages from "../../../form/SelectDropdownImages";
const DebitCreditCard = () => {
  return (
    <>
      <div className="relative mb-6">
        <Input
          inputClasses={
            "!bg-catskill-white !border-0 rounded-lg !h-12 !pr-12 !text-base"
          }
          inputPlaceholder={"Card number"}
        />
        <div className="absolute bottom-0 right-0 h-12 aspect-square flex items-center justify-center text-xl text-slate-400">
          <i className="fa-solid fa-fw fa-credit-card"></i>
        </div>
      </div>
      <div className="relative mb-6 grid grid-cols-5 gap-6">
        <div className="relative col-span-3">
          <Input
            inputClasses={
              "!bg-catskill-white !border-0 rounded-lg !h-12 !pr-12 !text-base"
            }
            inputPlaceholder={"MM / YY"}
          />
          <div className="absolute bottom-0 right-0 h-12 aspect-square flex items-center justify-center text-xl text-slate-400">
            <i className="fa-solid fa-fw fa-calendar"></i>
          </div>
        </div>
        <div className="relative col-span-2">
          <Input
            inputClasses={
              "!bg-catskill-white !border-0 rounded-lg !h-12 !pr-12 !text-base"
            }
            inputPlaceholder={"CVC"}
          />
          <div className="absolute bottom-0 right-0 h-12 aspect-square flex items-center justify-center text-xl text-slate-400">
            <i className="fa-solid fa-fw fa-lock"></i>
          </div>
        </div>
      </div>
    </>
  );
};

const PayPal = () => {
  return (
    <>
      <div className="relative mb-6">
        <Input
          inputClasses={
            "!bg-catskill-white !border-0 rounded-lg !h-12 !pr-12 !text-base"
          }
          inputPlaceholder={"PayPal"}
        />
        <div className="absolute bottom-0 right-0 h-12 aspect-square flex items-center justify-center text-xl text-slate-400">
          <i className="fa-brands fa-fw fa-paypal"></i>
        </div>
      </div>
    </>
  );
};

const Venmo = () => {
  return (
    <>
      <div className="relative mb-10">
        <div className="text-xl font-bold mb-4">Take action via Venmo</div>
        <div className="relative space-y-10 mb-10">
          <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
            <div className="flex-shrink-0 flex items-start">
              <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                <i className="fa-regular fa-check"></i>
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4">
              <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                <p>
                  <strong>Display name:</strong> V’Peters Family Scholarship
                </p>
                <p>
                  <strong>Venmo Username:</strong> $VPETERSFS
                </p>
              </div>
              <div className="overflow-hidden flex items-center justify-center relative max-w-60">
                <span
                  className={classNames(
                    "relative inline-flex items-center justify-center bg-transparent text-shades-07 font-CanelaDeck text-lg",
                    "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-shades-05/20 before:mt-0.5",
                    "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-shades-05/20 after:mt-0.5"
                  )}
                >
                  or
                </span>
              </div>
              <div className="space-y-2">
                <div className="text-chestnut-rose font-medium italic text-base">
                  Scan to Action
                </div>
                <div className="w-full max-w-60 rounded overflow-hidden shadow border border-shades-02">
                  <Image
                    src={VenmoScanImage}
                    alt={""}
                    effect="blur"
                    classes="object-contain object-left"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
            <div className="flex-shrink-0 flex items-start">
              <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                <i className="fa-regular fa-check"></i>
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4">
              <div className="text-lg font-medium">After your Action</div>
              <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                To get a receipt, email{" "}
                <strong>
                  <a href="mailto:contact@vpeters.org">contact@vpeters.org</a>
                </strong>{" "}
                with your name, email, amount, date and purpose.
              </div>
            </div>
          </div>
        </div>
        <div className="text-xs italic">
          <p>
            <strong>Note:</strong> All funds are used solely for scholarship
            support. <strong>Thank you for helping inspire the future!</strong>
          </p>
        </div>
      </div>
    </>
  );
};

const CashApp = () => {
  return (
    <>
      <div className="relative mb-10">
        <div className="text-xl font-bold mb-4">Take action via CashApp</div>
        <div className="relative space-y-10 mb-10">
          <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
            <div className="flex-shrink-0 flex items-start">
              <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                <i className="fa-regular fa-check"></i>
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4">
              <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                <p>
                  <strong>Display name:</strong> V’Peters Family Scholarship
                </p>
                <p>
                  <strong>Cash App Tags:</strong> $VPETERSFS
                </p>
              </div>
              <div className="overflow-hidden flex items-center justify-center relative max-w-60">
                <span
                  className={classNames(
                    "relative inline-flex items-center justify-center bg-transparent text-shades-07 font-CanelaDeck text-lg",
                    "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-shades-05/20 before:mt-0.5",
                    "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-shades-05/20 after:mt-0.5"
                  )}
                >
                  or
                </span>
              </div>
              <div className="space-y-2">
                <div className="text-chestnut-rose font-medium italic text-base">
                  Scan to Action
                </div>
                <div className="w-full max-w-60 rounded overflow-hidden shadow border border-shades-02">
                  <Image
                    src={CashAppScanImage}
                    alt={""}
                    effect="blur"
                    classes="object-contain object-left"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
            <div className="flex-shrink-0 flex items-start">
              <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                <i className="fa-regular fa-check"></i>
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4">
              <div className="text-lg font-medium">After your Action</div>
              <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                To get a receipt, email{" "}
                <strong>
                  <a href="mailto:contact@vpeters.org">contact@vpeters.org</a>
                </strong>{" "}
                with your name, email, amount, date and purpose.
              </div>
            </div>
          </div>
        </div>
        <div className="text-xs italic">
          <p>
            <strong>Note:</strong> All funds are used solely for scholarship
            support. <strong>Thank you for helping inspire the future!</strong>
          </p>
        </div>
      </div>
    </>
  );
};

const Zelle = () => {
  return (
    <>
      <div className="relative mb-10">
        <div className="text-xl font-bold mb-4">Take action via Zelle</div>
        <div className="relative space-y-10 mb-10">
          <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
            <div className="flex-shrink-0 flex items-start">
              <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                <i className="fa-regular fa-check"></i>
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4">
              <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                <p>
                  <strong>Recipient name:</strong> V’Peters Family Scholarship
                </p>
                <p>
                  <strong>Zelle email:</strong> contact@vpeters.org
                </p>
                <p>
                  <strong>Note/Purpose:</strong> Scholarship Support
                </p>
              </div>
            </div>
          </div>
          <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
            <div className="flex-shrink-0 flex items-start">
              <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                <i className="fa-regular fa-check"></i>
              </div>
            </div>
            <div className="flex-shrink flex-grow space-y-4">
              <div className="text-lg font-medium">
                After your Action email{" "}
                <strong>
                  <a href="mailto:contact@vpeters.org">contact@vpeters.org</a>
                </strong>{" "}
                with:
              </div>
              <div className="text-sm italic pl-5">
                <ul className="list-disc pl-5 space-y-0.5">
                  <li>Your full name</li>
                  <li>Action amount</li>
                  <li>Date of action</li>
                  <li>Purpose</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="text-xs italic">
          <p>
            <strong>Note:</strong> All funds are used solely for scholarship
            support. <strong>Thank you for helping inspire the future!</strong>
          </p>
        </div>
      </div>
    </>
  );
};

const ApplePay = () => {
  return (
    <>
      <div className="relative mb-6">
        <Input
          inputClasses={
            "!bg-catskill-white !border-0 rounded-lg !h-12 !pr-12 !text-base"
          }
          inputPlaceholder={"Apple Pay ID"}
        />
        <div className="absolute bottom-0 right-0 h-12 aspect-square flex items-center justify-center text-xl text-slate-400">
          <i className="fa-brands fa-fw fa-apple-pay"></i>
        </div>
      </div>
    </>
  );
};

const TakeActionStepThree = ({ setStep, formData, stepOneFormData, backHandler = () =>{} }) => {
  // const [morePayments, setMorePayments] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState();
  const [hasSentDonation, setHasSentDonation] = useState(false);
  const [paymentComponents, setPaymentComponents] = useState({});
  const [selectedPaymentdata, setSelectedPaymentData] = useState({});
  const [popOpen, setPopOpen] = useState({ isOpen: false, data: "" });

 
  const handleMessage = (e) => {
    setMessage(e.target.value);
  };
  const { data } = useFetch({
    dependencies: ["paymentMethod"],
    fetchFunction: async () => {
      const res = await paymentMethodList({
        limit: 9999,
        status: 1,
      });
      return res?.docs;
    },
  });
  const manualConfirmationMethods = Array.isArray(data?.data)
    ? data.data
        .filter(
          (item) =>
            (item?.stripePartner !== true && item?.isScanOrLink === "scan") ||
            item?.isType === "bank"
        )
        .map((item) => item.slug)
    : [];

  useEffect(() => {
    if (selectedPaymentMethod && Array.isArray(data?.data)) {
      const matchedData = data.data.find(
        (item) => item?.slug === selectedPaymentMethod
      );
      if (matchedData) {
        setSelectedPaymentData(matchedData);
      }
    }
  }, [selectedPaymentMethod, data?.data]);

  const onSubmit = async (values) => {
    if (!selectedPaymentMethod) {
      toast?.error("Please choose a payment method");
      return;
    }

    setLoading(true);
    const isManualMethod = manualConfirmationMethods?.includes(
      selectedPaymentMethod
    );
    const paymentPayload = {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      amount: stepOneFormData?.donationAmount,
      donationType: stepOneFormData?.donationType,
      donationFrequency: stepOneFormData?.donationFrequency,
      paymentMethod: selectedPaymentMethod,
      message: message,
      organizationName: stepOneFormData?.organizationName,

      recurringDate: stepOneFormData?.recurringDate,
    };
    if (selectedPaymentdata?.stripePartner === true) {
      paymentPayload.paymentType = "stripe";
    }
    else if (
      selectedPaymentdata?.isType === "app" && 
      (selectedPaymentdata?.isScanOrLink === "scan" ||
        selectedPaymentdata?.isScanOrLink === "link")
    ) {
      paymentPayload.isScanOrLink = selectedPaymentdata.isScanOrLink;
      paymentPayload.isSentDonation = hasSentDonation;
      paymentPayload.paymentType = "manual";
    }

    const paymentAction =
      stepOneFormData?.donationFrequency === "monthly"
        ? addMonthlyPayment
        : addOneTimePayment;

    try {
      const res = await paymentAction(paymentPayload);
      if (res?.status === 200) {
        if (res?.data?.url) {
          window.location.href = res.data.url;
        } else {
          setPopOpen({ isOpen: true, data: res?.message });
          // toast.success(res?.message);
        }
      } else {
        toast?.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      toast?.error("Network error or timeout. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const selectedPaymentMethodObject = data?.data?.find(
    (item) => item.slug === selectedPaymentMethod
  );
  const AppPaymentMethod = () => {
    return (
      <>
        <div className="relative mb-10">
          <div className="text-xl font-bold mb-4">
            Take action via {selectedPaymentMethodObject?.name}
          </div>
          <div className="relative space-y-10 mb-10">
            <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
              <div className="flex-shrink-0 flex items-start">
                <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                  <i className="fa-regular fa-check"></i>
                </div>
              </div>
              <div className="flex-shrink flex-grow space-y-4">
                <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                  {selectedPaymentMethodObject?.appOb?.sectionOne
                    ?.headingText && (
                    <p>
                      <strong>Display name:</strong>{" "}
                      {
                        selectedPaymentMethodObject?.appOb?.sectionOne
                          ?.headingText
                      }
                    </p>
                  )}
                  {selectedPaymentMethodObject?.appOb?.sectionOne
                    ?.appUserName && (
                    <p>
                      <strong>Recipient name:</strong>{" "}
                      {
                        selectedPaymentMethodObject?.appOb?.sectionOne
                          ?.appUserName
                      }
                    </p>
                  )}
                  {selectedPaymentMethodObject?.appOb?.sectionOne?.appId && (
                    <p>
                      <strong>
                        {selectedPaymentMethodObject?.name} Username:
                      </strong>{" "}
                      {selectedPaymentMethodObject?.appOb?.sectionOne?.appId}
                    </p>
                  )}
                  {selectedPaymentMethodObject?.appOb?.sectionOne?.appEmail && (
                    <p>
                      <strong>
                        {selectedPaymentMethodObject?.name} email:
                      </strong>{" "}
                      {selectedPaymentMethodObject?.appOb?.sectionOne?.appEmail}
                    </p>
                  )}
                  {selectedPaymentMethodObject?.appOb?.sectionOne?.note && (
                    <p>
                      <strong>Note/Purpose:</strong>{" "}
                      {selectedPaymentMethodObject?.appOb?.sectionOne?.note}
                    </p>
                  )}
                </div>
                {selectedPaymentMethodObject?.paymentImage?.url && (
                  <>
                    <div className="overflow-hidden flex items-center justify-center relative max-w-60">
                      <span
                        className={classNames(
                          "relative inline-flex items-center justify-center bg-transparent text-shades-07 font-CanelaDeck text-lg",
                          "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-shades-05/20 before:mt-0.5",
                          "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-shades-05/20 after:mt-0.5"
                        )}
                      >
                        or
                      </span>
                    </div>
                    <div className="space-y-2">
                      <div className="text-chestnut-rose font-medium italic text-base">
                        Scan to Action
                      </div>
                      <div className="w-full max-w-60 rounded overflow-hidden shadow border border-shades-02">
                        <Image
                          src={selectedPaymentMethodObject?.paymentImage?.url}
                          alt={""}
                          effect="blur"
                          classes="object-contain object-left"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
              <div className="flex-shrink-0 flex items-start">
                <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl">
                  <i className="fa-regular fa-check"></i>
                </div>
              </div>
              <div className="flex-shrink flex-grow space-y-4">
                <div className="text-lg font-medium">
                  After your Action email{" "}
                  <strong>
                    <a
                      href={`${selectedPaymentMethodObject?.appOb?.sectionOne?.appEmail}`}
                    >
                      {selectedPaymentMethodObject?.appOb?.sectionOne?.appEmail}
                    </a>
                  </strong>{" "}
                  with:
                </div>
                <div className="text-sm italic pl-5">
                  <ul className="list-disc pl-5 space-y-0.5">
                    {selectedPaymentMethodObject?.appOb?.sectionTwo?.afterAction?.pointField?.map(
                      (item) => (
                        <li>{item}</li>
                      )
                    )}
                  </ul>
                </div>
                <div className="flex-shrink-0 text-sm space-y-0.5 italic">
                  {
                    selectedPaymentMethodObject?.appOb?.sectionTwo?.afterAction
                      ?.note
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="text-xs italic">
            <p
              dangerouslySetInnerHTML={{
                __html: selectedPaymentMethodObject?.note,
              }}
            ></p>
          </div>
        </div>
      </>
    );
  };

  const MoneyGram = () => {
    return (
      <>
        <div className="relative mb-10">
          <div className="text-xl font-bold mb-4">
            Take action via {selectedPaymentMethodObject?.name}
          </div>
          <div className="relative space-y-10">
            <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
              <div className="flex-shrink-0 flex items-start">
                <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl pb-1">
                  1
                </div>
              </div>
              <div className="flex-shrink flex-grow">
                <p>Visit a {selectedPaymentMethodObject?.name} location or</p>
                <p>
                  <a
                    href={`https://${selectedPaymentMethodObject?.appOb?.sectionOne?.appLink}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-chestnut-rose"
                  >
                    {selectedPaymentMethodObject?.appOb?.sectionOne?.appLink}
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="flex gap-8 relative z-0 before:content-[''] before:absolute before:top-0 before:left-5 before:h-[calc(100%+2.5rem)] last:before:h-full before:border before:-mx-px before:z-[-1] before:border-shades-05/50">
              <div className="flex-shrink-0 flex items-start">
                <div className="w-10 aspect-square flex-shrink-0 bg-chestnut-rose text-white font-CanelaDeck font-bold rounded-full flex items-center justify-center text-2xl pb-1">
                  2
                </div>
              </div>
              <div className="flex-shrink flex-grow space-y-4">
                <div className="text-lg font-medium">Send to:</div>
                <div className="flex items-center">
                  <div className="flex-shrink-0 px-4 border-r border-shades-05/50 text-sm space-y-0.5">
                    <p>
                      <i>
                        {
                          selectedPaymentMethodObject?.appOb?.sectionOne
                            ?.headingText
                        }
                      </i>
                    </p>
                    <p>
                      <i>
                        Attn:{" "}
                        {
                          selectedPaymentMethodObject?.appOb?.sectionOne
                            ?.appUserName
                        }
                      </i>
                    </p>
                    <p>
                      <i>
                        City:{" "}
                        {selectedPaymentMethodObject?.appOb?.sectionTwo?.city}
                      </i>
                    </p>
                    <p>
                      <i>
                        State:{" "}
                        {selectedPaymentMethodObject?.appOb?.sectionTwo?.state}
                      </i>
                    </p>
                    <p>
                      <i>
                        Country:{" "}
                        {
                          selectedPaymentMethodObject?.appOb?.sectionTwo
                            ?.country
                        }
                      </i>
                    </p>
                  </div>
                  <div className="flex-shrink flex-grow px-4">
                    <div className="flex flex-col items-center justify-center gap-4">
                      <div className="text-3xl text-chestnut-rose">
                        <i className="fa-regular fa-circle-exclamation-check"></i>
                      </div>
                      <div className="text-xs">
                        Double check name and location to avoid delay.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="relative pl-20 ml-2 my-10">
            <div className="font-semibold mb-4">
              After taking action, email us at{" "}
              <a
                href={`${selectedPaymentMethodObject?.appOb?.sectionOne?.appEmail}`}
                className="text-chestnut-rose"
              >
                {selectedPaymentMethodObject?.appOb?.sectionOne?.appEmail}
              </a>
            </div>
            <div className="text-sm italic">
              <ul className="list-disc pl-5 space-y-0.5">
                {selectedPaymentMethodObject?.appOb?.sectionTwo?.afterAction?.pointField?.map(
                  (item) => (
                    <li>{item}</li>
                  )
                )}
              </ul>
            </div>
          </div>
          <div className="text-xs italic">
            <p
              dangerouslySetInnerHTML={{
                __html: selectedPaymentMethodObject?.note,
              }}
            ></p>
          </div>
        </div>
      </>
    );
  };

  const Bank = () => {
    return (
      <>
        <div className="relative mb-10 space-y-4">
          <div className="text-xl font-bold">Bank Transfer Details:</div>
          <div className="space-y-4 text-sm font-CanelaDeck">
            <ul className="my-2 px-4 py-3 border border-shades-05/20 bg-shades-03 rounded-lg w-auto mr-auto inline-block">
              <li>
                <strong>Account Name:</strong>
                {selectedPaymentMethodObject?.bankOb?.accName}
              </li>
              <li>
                <strong>Bank Name:</strong>{" "}
                {selectedPaymentMethodObject?.bankOb?.bName}
              </li>
              <li>
                <strong>Account Number:</strong>{" "}
                {selectedPaymentMethodObject?.bankOb?.accNumber}
              </li>
              <li>
                <strong>Routing Number (for U.S. transfers):</strong>{" "}
                {selectedPaymentMethodObject?.bankOb?.routingNumber}
              </li>
              <li>
                <strong>SWIFT Code (for international transfers):</strong>{" "}
                {selectedPaymentMethodObject?.bankOb?.swiftCode}
              </li>
              <li>
                <strong>Bank Address:</strong>{" "}
                {selectedPaymentMethodObject?.bankOb?.bankAddress}
              </li>
              <li>
                <strong>Note/Purpose:</strong>{" "}
                {selectedPaymentMethodObject?.bankOb?.note}
              </li>
            </ul>
            <p>
              <strong>After Sending Your Transfer:</strong>
            </p>
            {/* <p>
              Please <strong>email us</strong> at{" "}
              <a href="mailto:contact@vpeters.org" className="text-chestnut-rose">
                contact@vpeters.org
              </a>{" "}
              with the following details to help us confirm and acknowledge your contribution:
            </p> */}
            <p
              dangerouslySetInnerHTML={{
                __html: selectedPaymentMethodObject?.bankOb?.afterAction?.note,
              }}
            ></p>
            {/* <ul className="my-2 px-4 py-3 border border-shades-05/20 bg-shades-03 rounded-lg w-auto mr-auto inline-block">
              <li>Your full name</li>
              <li>Amount sent</li>
              <li>Date of transfer</li>
              <li>Purpose (e.g., Scholarship Support)</li>
            </ul> */}
            <ul className="my-2 px-4 py-3 border border-shades-05/20 bg-shades-03 rounded-lg w-auto mr-auto inline-block">
              {selectedPaymentMethodObject?.bankOb?.afterAction?.pointField?.map(
                (item) => (
                  <li>{item}</li>
                )
              )}
            </ul>

            {/* <p>
              <strong>Note:</strong>{" "}
              <i>
                Funds sent via Bank transfer are received by Dr. Peete V’Peters on behalf of the V’Peters Family
                Scholarship and used solely for scholarship support.
              </i>
            </p>
            <p>
              Thank you for supporting the <strong>V’Peters Family Scholarship: Inspire Future!</strong>
            </p> */}
            <p
              dangerouslySetInnerHTML={{
                __html: selectedPaymentMethodObject?.note,
              }}
            ></p>
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (Array.isArray(data?.data)) {
      const components = {};

      data.data.forEach((item) => {
        if (
          item?.isType === "app" &&
          item?.isScanOrLink === "scan" &&
          item?.stripePartner !== true
        ) {
          components[item.slug] = <AppPaymentMethod />;
        } else if (item?.isType === "bank") {
          components[item.slug] = <Bank />;
        }
      });

      setPaymentComponents(components);
    }
  }, [data, selectedPaymentMethod]);

  // const paymentComponents = {
  //   // debit_credit_card: <DebitCreditCard />,
  //   paypal: <AppPaymentMethod />,
  //   venmo: <AppPaymentMethod />,
  //   cashapp: <AppPaymentMethod />,
  //   paytm: <AppPaymentMethod />,
  //   bank_transfer: <Bank />,
  //   zelle: <AppPaymentMethod />,
  //   apple_pay: <AppPaymentMethod />,
  //   moneygram: <MoneyGram />,
  //   mail_in_action: <></>,
  // };
  useEffect(() => {
    setHasSentDonation(false);
  }, [selectedPaymentMethod]);
  return (
    <>
      <div className="relative py-10 px-0 space-y-10">
        <div className="relative">
          <div className="relative mb-6">
            <div className="flex gap-4 items-center flex-wrap xls:flex-row">
              <SelectDropdownImages
                label={"Choose payment method"}
                xPlacement={"bottomRight"}
                labelClasses={
                  "mb-3 text-gable-green font-medium text-base sm:text-lg"
                }
                dropdownButtonClass={"!h-14 !rounded-lg !text-base"}
                dropdownClass={""}
                optionsClass={"!text-base"}
                dropdownData={
                  data?.data?.map((item) => ({
                    name: item?.name,
                    value: item?.slug,
                    image: item?.image?.url,
                  })) || []
                }
                selectedValue={selectedPaymentMethod}
                setSelectedValue={setSelectedPaymentMethod}
                placeholder={"Choose a payment method"}
              />
            </div>
          </div>

       
          {paymentComponents[selectedPaymentMethod]}

          <div className="relative mb-6">
            <div className="mb-3 text-gable-green font-medium text-base sm:text-lg">
              Total Amount
            </div>
            <div className="text-gable-green font-bold text-2xl sm:text-3xl font-CanelaDeck">
              ${stepOneFormData?.donationAmount || 0}
            </div>
          </div>

          {/* Optional message field for applicable methods */}

          <div className="relative mb-6 max-w-2xl mx-auto">
            <Textarea
              label={"Message (Optional)"}
              labelClasses={"mb-2 !text-gable-green !text-base sm:!text-lg"}
              inputClasses={"bg-transparent rounded-lg !text-base"}
              inputPlaceholder={""}
              inputValue={message}
              onChange={handleMessage}
            />
          </div>

          {/* Checkbox for manual confirmation methods */}
          {manualConfirmationMethods.includes(selectedPaymentMethod) && (
            <div className="mb-6 flex items-center space-x-3">
              <Checkbox
                checkboxLabel={" I’ve Sent My Donation"}
                checkboxLableClass={
                  "!font-bold !text-gable-green !font-medium !text-lg sm:!text-xl"
                }
                checkboxName={"hasSentDonation"}
                checked={hasSentDonation}
                onChange={(e) => setHasSentDonation(e.target.checked)}
              />
            </div>
          )}

          {/* Submit Button */}
          <div className="relative flex justify-center mt-4 gap-4">
           <Button
                buttonLabel={"Back"}
                buttonType={"button"}
                buttonClasses={"!h-10 xls:!h-12 !rounded-full !px-6 xls:!px-10 !border !border-chestnut-rose !bg-white !text-chestnut-rose"}
                buttonLabelClasses={"text-base xls:!text-lg"}
                buttonFunction={() => backHandler()}
              />
            <Button
              buttonLabel={"Take Action"}
              buttonClasses="!h-10 xls:!h-12 !rounded-full !px-6 xls:!px-10 w-full sm:w-auto"
              buttonHasLink={""}
              buttonFunction={() => onSubmit()}
              buttonLabelClasses="text-base xls:!text-lg"
              isDisable={
                loading ||
                (manualConfirmationMethods.includes(selectedPaymentMethod) &&
                  !hasSentDonation)
              }
            />
          </div>
        </div>

        {/* Modal */}
        <PopUpModal
          open={popOpen?.isOpen}
          onClose={() => {
            setPopOpen({ isOpen: false, data: "" });
            setStep(4);
          }}
          title={"Payment Confirmation"}
          customMessage={popOpen?.data}
        />
      </div>
    </>
  );
};

export default TakeActionStepThree;
